import React from "react";
import { SVG } from "shared";
import { SVG_ENUM, FILE_TYPE_ENUM } from "enums";
import moment from "moment";
import { FileType } from "types/FileTypes";
import "./RodoInformation.scss";

interface RodoInformationProps {
  rodoAcceptedAt?: string | null;
  files?: FileType[];
}

const RodoInformation: React.FC<RodoInformationProps> = ({
  rodoAcceptedAt,
  files,
}) => {
  const rodoFile = files?.find((file) => file.type === FILE_TYPE_ENUM.RODO);
  return (
    <div>
      {rodoAcceptedAt ? (
        <div className="rodo-information">
          <SVG type={SVG_ENUM.CIRCLE_CHECKED_GREEN} />
          <span className="rodo-information__date">
            {moment(rodoAcceptedAt).format("DD.MM.YYYY")}
          </span>
          {rodoFile ? (
            <div className="rodo-information__files">
              <a href={rodoFile.url} target="_blank" rel="noreferrer">
                <SVG type={SVG_ENUM.FILE} />
              </a>
            </div>
          ) : null}
        </div>
      ) : (
        "-"
      )}
    </div>
  );
};

export default RodoInformation;
